module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/ME-cd576a8c3938c3e2860a7b2e4d78014d.png";